function renderFaqList(container, items, idPrefix = "faq") {
  container.innerHTML = items
    .map(
      (item, i) => `
    <li class="faq__item" data-category="${item.category || ""}">
      <button
        type="button"
        class="faq__question"
        aria-expanded="false"
        aria-controls="${idPrefix}-answer-${i}"
        id="${idPrefix}-q-${i}"
      >
        <span class="faq__question-text">${item.q}</span>
        <span class="faq__icon" aria-hidden="true"></span>
      </button>
      <div
        class="faq__answer"
        id="${idPrefix}-answer-${i}"
        role="region"
        aria-labelledby="${idPrefix}-q-${i}"
        hidden
      >
        <p>${item.a}</p>
      </div>
    </li>
  `
    )
    .join("");

  initFaqAccordion(container);
}

function initFaqAccordion(container) {
  container.querySelectorAll(".faq__question").forEach((button) => {
    button.addEventListener("click", () => {
      const isOpen = button.getAttribute("aria-expanded") === "true";
      const answer = document.getElementById(button.getAttribute("aria-controls"));
      const item = button.closest(".faq__item");

      button.setAttribute("aria-expanded", String(!isOpen));
      answer.hidden = isOpen;
      item.classList.toggle("is-open", !isOpen);
    });
  });
}

function mountFaqFilters(listContainer, filtersContainer, emptyEl, searchInput) {
  let activeFilter = "all";
  let searchQuery = "";
  const categories = window.FAQ_CATEGORIES || [];
  const allItems = window.FAQ_ITEMS || [];

  function getFilteredItems() {
    let items =
      activeFilter === "all"
        ? allItems
        : allItems.filter((item) => item.category === activeFilter);

    const query = searchQuery.trim().toLowerCase();
    if (query) {
      items = items.filter(
        (item) =>
          String(item.q || "")
            .toLowerCase()
            .includes(query) ||
          String(item.a || "")
            .toLowerCase()
            .includes(query)
      );
    }

    return items;
  }

  function renderFiltered() {
    const items = getFilteredItems();
    renderFaqList(listContainer, items, listContainer.dataset.faqPrefix || "faq-page");

    if (emptyEl) {
      emptyEl.hidden = items.length > 0;
      if (!emptyEl.hidden) {
        const query = searchQuery.trim();
        if (query) {
          emptyEl.textContent = `No questions match "${query}".`;
        } else if (activeFilter !== "all") {
          emptyEl.textContent = "No questions in this category.";
        } else {
          emptyEl.textContent = "No questions found.";
        }
      }
    }
  }

  const usedCategories = new Set(
    allItems.map((item) => item.category).filter((c) => c && c !== "all")
  );
  const visibleCategories = categories.filter(
    (cat) => cat.id === "all" || usedCategories.has(cat.id)
  );

  filtersContainer.innerHTML = "";
  if (visibleCategories.length > 1) {
    visibleCategories.forEach((cat) => {
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "faq-filter";
      if (cat.id === "all") btn.classList.add("is-active");
      btn.dataset.filter = cat.id;
      btn.textContent = cat.label;
      btn.addEventListener("click", () => {
        activeFilter = cat.id;
        filtersContainer.querySelectorAll(".faq-filter").forEach((b) => {
          b.classList.toggle("is-active", b.dataset.filter === cat.id);
        });
        renderFiltered();
      });
      filtersContainer.appendChild(btn);
    });
  }

  if (searchInput) {
    searchInput.addEventListener("input", () => {
      searchQuery = searchInput.value;
      renderFiltered();
    });
  }

  renderFiltered();
}

function mountFaq() {
  const allItems = window.FAQ_ITEMS || [];

  document.querySelectorAll("[data-faq-list]").forEach((container) => {
    const limit = container.dataset.faqLimit;
    const prefix = container.dataset.faqPrefix || "faq";
    const filtersContainer = document.querySelector("[data-faq-filters]");

    if (filtersContainer && !limit) {
      const emptyEl = document.getElementById("faq-empty");
      const searchInput = document.getElementById("faq-search");
      mountFaqFilters(container, filtersContainer, emptyEl, searchInput);
      return;
    }

    const items = limit ? allItems.slice(0, parseInt(limit, 10)) : allItems;
    renderFaqList(container, items, prefix);
  });
}

document.addEventListener("DOMContentLoaded", mountFaq);
